import { getClubInfo } from "@/http/clubsApi";
import { getClubInfoQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetClubInfoQuery = (clubId: string) => {
  return useQuery({
    queryKey: [...getClubInfoQueryKey(), clubId],
    queryFn: () => getClubInfo(clubId),
    enabled: !!clubId,
  });
};
